import { captureMessage } from '@sentry/browser'
import { isEnabled } from './info'

const logMessage = (...args) => {
  isEnabled() ? captureMessage(...args) : console.log(...args) // eslint-disable-line no-console
}

export default logMessage
